/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { SipCallCallReceivedPathParameters } from 'api/actions/sip-call-call-received/sip-call-call-received-path-parameters';
import { SipCallCallReceivedResponse } from 'api/actions/sip-call-call-received/sip-call-call-received-response';

type SipCallCallReceivedQueryParameters = Record<string, any>;

/**
 * The path of the SipCallCallReceived action.
 */
export const sipCallCallReceivedActionPath = new SweetPath<keyof SipCallCallReceivedPathParameters>(
  '/sip/call/{id}/call-received',
  { path: '{param}' }
);

/**
 * Creates a contextualized SipCallCallReceived actions.
 */
export default function createSipCallCallReceivedAction(axios: AxiosInstance) {
  return function sipCallCallReceivedAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: SipCallCallReceivedPathParameters;
    query?: SipCallCallReceivedQueryParameters;
  }) {
    const path = sipCallCallReceivedActionPath.insert(parameters);

    return axios.post<SipCallCallReceivedResponse, SipCallCallReceivedResponse>(path, { params: query, headers });
  };
}
